import { ButtonGroup, PrimaryButton } from "@certn/cascadia";
import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  Dialog,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  onClose?: () => void;
}

export function MissingRequiredDocumentsModal(props: Props) {
  const { t } = useTranslation();
  return (
    <Dialog>
      <>
        <DialogHeader onClose={props.onClose}>
          {t("Missing Required Documents")}
        </DialogHeader>
        <DialogContent>
          {t(
            "To submit your dispute, you must attach the completed dispute form along with any supporting documents (if applicable). Please upload the necessary file(s) and try again."
          )}
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <PrimaryButton size="medium" onPress={props.onClose}>
              {t("Okay")}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </>
    </Dialog>
  );
}
